<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：定制-定制设置
      -->
  <div class="product-add" v-loading="loading">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <div class="common-form">定制设置</div>
      <el-form-item label="是否开启定制: ">
        <el-radio-group v-model="form.is_customization">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="定制名称 ">
        <el-input v-model="form.customization_name" class="max-w460"></el-input>
        <div class="lh18 mt10 gray9">
          <p>注：修改定制名称后，在买家端的所有页面里，看到的都是自定义的名称</p>
        </div>
      </el-form-item>
      <el-form-item label="起订量: ">
          <el-input v-model="form.minimum_order_quantity" placeholder="请输入起订量" type="number" style="width: 200px;">
            <template slot="append">瓶</template>
          </el-input>
      </el-form-item>
      <el-form-item label="定金: ">
          <el-input v-model="form.deposit" placeholder="请输入定金" type="number" style="width: 200px;">
            <template slot="append">元</template>
          </el-input>
      </el-form-item>
      <el-form-item label="定制合同">
        <el-select v-model="form.contract_id">
          <el-option :value="List.id" :label="List.title" :key="List.id" v-for="List in ContractList"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="定制图片：" :rules="[{ required: true, message: '请上传定制图片' }]" prop="image">
        <div slot="label">定制图片：</div>
        <div class="draggable-list">
          <draggable class="wrapper" v-model="form.image">
            <transition-group>
              <div class="item" v-for="(item, index) in form.image" :key="item.file_path">
                <img v-img-url="item.file_path" />
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </transition-group>
          </draggable>
          <div class="item img-select" @click="openStoreUpload"><i class="el-icon-plus"></i></div>
        </div>
      </el-form-item>
      <el-form-item label="定制说明:" v-if="!loading">
        <div class="edit_container">
          <Uediter :text="form.content" id="ue1" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>
      <el-form-item label="订购协议:" v-if="!loading">
        <div class="edit_container">
          <Uediter :text="form.agreement" id="ue2" @contentChange="agreementChangeFunc"></Uediter>
        </div>
      </el-form-item>

      <!--提交-->
      <div style="height: 100px;"></div>
      <div class="common-button-wrapper">
         <el-button type="primary" @click="onSubmit" :loading="loading">保存</el-button>
      </div>
    </el-form>

    <!--上传图片组件-->
    <Upload v-if="isStoreUpload" :config="{ total: 9 }" :isupload="isStoreUpload" @returnImgs="returnStoreImgsFunc">上传图片</Upload>
  </div>
</template>
<script>
  import CustomizationApi from '@/api/customization.js';
  import Uediter from '@/components/UE.vue';
  import Upload from '@/components/file/Upload';
  import draggable from 'vuedraggable';
  export default {
    components: {
      /*编辑器*/
      Uediter,
      Upload,
      draggable
    },
    data() {
      return {
        form: {
          is_customization: 0,
          customization_name:'',
          minimum_order_quantity: 0,
          deposit: 0,
          contract_id: '',
          content: '',
          agreement: '',
          image:[],
        },
        ContractList:[],
        /*富文本框配置*/
        ueditor: {
          text: '',
          config: {
            initialFrameWidth: 400,
            initialFrameHeight: 500
          }
        },
        /*是否正在加载*/
        loading: true,
        /*是否上传图片*/
        isStoreUpload:false,


      };
    },
    created() {
      /*获取列表*/
      this.getSetting();
    },
    methods: {
      /*获取设置*/
      getSetting() {
        let self = this;
        let Params = {};
        CustomizationApi.getSetting(Params, true)
          .then(data => {
            self.form = data.data.customization;
            self.ContractList = data.data.ContractList.data;
            self.loading = false;
          })
          .catch(error => {});
      },
      /*获取富文本内容*/
      contentChangeFunc(e){
        this.form.content=e;
      },
      /*获取富文本内容*/
      agreementChangeFunc(e){
        this.form.agreement=e;
      },
      /*点击保存*/
      onSubmit() {
        let self = this;
        let params = self.form;
        self.loading = true;
        if(params.contract_id == 0){
          self.$message({
            message: '请选择定制合同',
            type: 'error'
          });
          self.loading = false;
          return false;
        }
        CustomizationApi.editSetting(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，保存成功',
                type: 'success'
              });
              self.getSetting();
            } else {
              self.loading = false;
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*打开上传图片*/
      openStoreUpload: function() {
        this.isStoreUpload = true;
      },
      /*上传商品图片*/
      returnStoreImgsFunc(e) {
        if (e != null) {
          let imgs = [];
          if(this.form.image){
            imgs = this.form.image.concat(e);
          }else{
            imgs = e;
          }
          this.$set(this.form, 'image', imgs);
        }
        this.isStoreUpload = false;
      },

      /*删除商品图片*/
      deleteImg(index) {
        this.form.image.splice(index, 1);
      },
    }
  };
</script>

<style>
  .draggable-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .draggable-list .wrapper > span {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .draggable-list .item {
    position: relative;
    width: 110px;
    height: 110px;
    margin-top: 10px;
    margin-right: 10px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dddddd;
  }

  .draggable-list .delete-btn {
    position: absolute;
    top: 0;
    right: 0;
    width: 16px;
    height: 16px;
    background: red;
    line-height: 16px;
    font-size: 16px;
    color: #ffffff;
    display: none;
  }

  .draggable-list .item:hover .delete-btn {
    display: block;
  }

  .draggable-list .item img {
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    max-height: 100%;
    max-width: 100%;
  }

  .draggable-list .img-select {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dddddd;
    font-size: 30px;
  }

  .draggable-list .img-select i {
    color: #409eff;
  }
</style>



// WEBPACK FOOTER //
// src/views/customization/setting/index.vue